<template>
  <div class="d-flex align-center">
    <!-- <template
      v-if="attendance.comment && attendance.comment.comment"
      class="font-weight-bold"
    >
      {{ attendance.comment.comment }}
    </template>
    <div v-else class="text--disabled">
      メモがまだ登録されていません
    </div> -->
    <v-textarea
      variant="solo"
      flat
      hide-details
      rows="1"
      auto-grow
      name="comment"
      placeholder="コメントを入力"
      prepend-inner-icon="mdi-note-outline"
      v-model="inputComment"
      clearable
      class="comment-area"
      style="white-space:pre-wrap;"
    ></v-textarea>
    <v-btn color="primary" variant="text" @click="saveComment" :loading="commentLoading">
      保存
    </v-btn>
  </div>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';
import { NurseryChildResponse, NurseryTemperatureResponse } from 'chaild-api/lib';
import { chatModule } from '@/store/dataModules/chatModule';

// model
// import { VForm } from '@/model/vuetify/VForm';

export default defineComponent({
  name: 'MemoForm',

  props: {
    child: {
      type: Object as PropType<NurseryChildResponse>,
      default: null,
    },
    date: {
      type: Object as PropType<any>,
      default: {},
    },
    comment: {
      type: Array as PropType<string[]>,
      default: [],
    },
  },

  computed: {},

  data: () => ({
    inputComment: '',
    commentLoading: false,
  }),

  methods: {
    async saveComment() {
      if (this.inputComment && this.child) {
        try {
          this.commentLoading = true;
          await chatModule.saveComment({
            childId: this.child.childId,
            date: this.date.format('YYYY-MM-DD'),
            comment: this.inputComment,
          });
          this.$emit('saveComment', 'コメント保存しました');
        } catch {
        } finally {
          this.commentLoading = false;
        }
      }
    },
  },
  mounted() {
    if (this.comment.length > 0) {
      this.inputComment = this.comment[0];
    }
  },
});
</script>
<style lang="scss" scoped>
v-textarea {
  height: 24px;
}

</style>
